export default "__VITE_ASSET__BRIXpOVc__"